/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import ManagementReportBalance from './ManagementReportBalance'
import { useMutation } from '@tanstack/react-query'
import { deleteTransaction } from '../../lib/rest/transactionAPIClient'
import { useState } from 'react'
import DeleteModal from '../../../../client/js/components/modals/DeleteModal'
import { Accordion, Stack, Table } from '@mantine/core'
import ManagementReportPeriod from './ManagementReportPeriod'
import NoDataAlert from '../../../../client/js/components/NoDataAlert'

export type ManagementReportProps = {
  data: ManagementReportData,
  defaultPeriod?: string,
  isManagementReport: boolean,
  onRefresh (): void,
}

function ManagementReport (props: ManagementReportProps) {
  const {
    data,
    defaultPeriod,
    isManagementReport,
    onRefresh
  } = props

  const [activePeriod, setActivePeriod] = useState<string | null>(defaultPeriod)
  const [itemToDelete, setItemToDelete] = useState<ManagementReportItem>()

  const deleteMutation = useMutation({
    mutationKey: ['deleteTransaction', itemToDelete?.id],
    mutationFn: async () => deleteTransaction(itemToDelete?.id),
    onSuccess: () => onRefresh()
  })

  return (
    <Stack>
      {data.periods.length === 0
        ? <NoDataAlert />
        : <Accordion
          transitionDuration={0}
          onChange={setActivePeriod}
          value={data.periods.length === 1 ? data.periods[0].period : activePeriod}
        >
          {data.periods.map((period) => (
            <ManagementReportPeriod
              key={period.period}
              customerId={data.customerId}
              estateId={data.estateId}
              isManagementReport={isManagementReport}
              onDeleteItem={setItemToDelete}
              period={period}
            />
          ))}
        </Accordion>}

      {data.periods.length > 1
        ? <Table bg="gray.0">
          <ManagementReportBalance data={data} />
        </Table>
        : null}

      <DeleteModal
        opened={itemToDelete != null}
        label={itemToDelete?.label}
        onConfirm={() => deleteMutation.mutateAsync()}
        onClose={() => {
          setItemToDelete(undefined)
        }}
      />
    </Stack>
  )
}

export default ManagementReport
